<!-- top components -->
@if(canShowTopOutlet) {
<icms-outlet class="block"
             [components]="content?.topComponents"
             [allowOnly]="['product_carousel_layout']"
             [allow]="['product_carousel_layout']">
</icms-outlet>
}

@if (product && content) {
<div class="wrap-x wrap-l wrap-m"
     bottomPanelArea="pdpButton">
    <!-- top section -->
    <breadcrumbs class="wrap-s block no-scrollbar overflow-auto"></breadcrumbs>
    <!-- `.flex` class is required for `stickyPanel` -->
    <div class="m-t">
        <!-- media -->
        <div class="c-6-l c-12-s c-12-m c-7-x m-b-0">
            <ng-container *ngTemplateOutlet="PDPLeftColumn"></ng-container>
        </div>
        <ng-container *ifSize="'SM'"><ng-container *ngTemplateOutlet="saleBanner"></ng-container></ng-container>
        <div class="c-6-l c-12-s c-12-m c-5-x m-r-0 m-b-0 pos-relative wrap-s wrap-m">
            <ng-container *ngTemplateOutlet="PDPRightColumn"></ng-container>
        </div>
    </div>
</div>
}

<!-- bottom components -->
<icms-outlet class="block"
             [components]="content?.bottomComponents"
             [allowOnly]="['ugc-image-gallery-product-view', 'related-products', 'product-reviews', 'product_carousel_layout', 'category-carousel', 'social-media-carousel', 'product-range-banner-wrapper', 'text']"
             [allow]=" ['ugc-image-gallery-product-view', 'related-products', 'product-reviews', 'product_carousel_layout', 'category-carousel', 'social-media-carousel', 'product-range-banner-wrapper', 'text']"
             [options]="{ productPageDisplayRules: true, context: product }">
</icms-outlet>

<ng-template #saleBanner>
    @if (product.data?.sale_banner) {
    <product-sale-banner [product]="product"
                         [content]="content" />
    }
</ng-template>

<ng-template #PDPLeftColumn>
    <!-- media -->
    <product-view-media [source]="product"></product-view-media>
    <product-view-description class="wrap-s"
                              [product]="product"
                              [content]="content"
                              *ifSize="'!SM'" />
    <product-range-content class="m-t-10"
                           [variant]="product.rangeContentVariant"
                           *ifSize="'!SM'" />
</ng-template>

<ng-template #PDPRightColumn>
    <ng-container *ifSize="'XL'"><ng-container *ngTemplateOutlet="saleBanner"></ng-container></ng-container>
    <!-- details -->
    <product-view-details class="w-12 p-b-8 p-b-6-m p-b-6-s"
                          [product]="product"
                          [content]="content"
                          [specSections]="content?.attributes" />
    <button type="button"
            class="w-12 flex flex-justify-between p-t-3 p-b-3 b-b p-l-2 p-r-2"
            [dialogOpen]="'dimensionsAndDetailsModalRight'">
        <span class="p2">{{'Dimensions & Details' | translate}}</span>
        <i class="icon-chevron-right p-t-1 p-r-1"
           [style.font-size.rem]="0.8"
           aria-hidden="true"></i>
    </button>
    <dialog [id]="'dimensionsAndDetailsModalRight'"
            [side]="'right'">
        <ng-container ngProjectAs="[dialogTitle]">
            {{'Dimensions & Details' | translate}}
        </ng-container>
        <product-view-dimensions-and-details-modal-right [content]="content"
                                                         [product]="product" />
    </dialog>
    <!-- delivery-->
    <button type="button"
            class="w-12 flex flex-justify-between p-t-3 p-b-3 b-b b-col-4 p-l-2 p-r-2"
            [dialogOpen]="deliveryModalId">
        <span class="p2">{{'Delivery' | translate}}</span>
        <i class="icon-chevron-right p-t-1 p-r-1"
           [style.font-size.rem]="0.8"
           aria-hidden="true"></i>
    </button>
    <dialog [id]="deliveryModalId"
            [side]="'right'">
        <ng-container ngProjectAs="[dialogTitle]">
            {{'Delivery' | translate}}
        </ng-container>
        <product-view-delivery-modal [variant]="product.deliveryVariant" />
    </dialog>
    @if (product.data?.careinfo) {
    <button type="button"
            class="w-12 flex flex-justify-between p-t-3 p-b-3 b-b b-col-4 p-l-2 p-r-2"
            [dialogOpen]="careInformationModalId">
        <span class="p2">{{'Care information' | translate}}</span>
        <i class="icon-chevron-right p-t-1 p-r-1"
           [style.font-size.rem]="0.8"
           aria-hidden="true"></i>
    </button>
    <dialog [id]="careInformationModalId"
            [side]="'right'">
        <ng-container ngProjectAs="[dialogTitle]">
            {{'Care information' | translate}}
        </ng-container>
        <product-view-care-information-modal [variant]="product.data.sku" />
    </dialog>
    }
    <!-- see in store -->
    @if (!product.isConfigurable && !product.isClearance && !product.data.next) {
    <button type="button"
            class="w-12 flex flex-justify-between p-t-3 p-b-3 b-b b-col-4 p-l-2 p-r-2"
            [dialogOpen]="seeInStoreModalId">
        <span class="p2">{{'See in store' | translate}}</span>
        <i class="icon-chevron-right p-t-1 p-r-1"
           [style.font-size.rem]="0.8"
           aria-hidden="true"></i>
    </button>
    <dialog [id]="seeInStoreModalId"
            [side]="'right'">
        <ng-container ngProjectAs="[dialogTitle]">
            {{'Our locations' | translate}}
        </ng-container>
        <product-view-see-in-store-modal [product]="product" />
    </dialog>
    }
    <!-- warranty and returns -->
    @if (product.isWarrantyAndReturns) {
    <button type="button"
            class="w-12 flex flex-justify-between p-t-3 p-b-3 b-b b-col-4 p-l-2 p-r-2"
            [dialogOpen]="warrantyAndReturnsModalId">
        <span class="p2">{{'Warranty & Returns' | translate}}</span>
        <i class="icon-chevron-right p-t-1 p-r-1"
           [style.font-size.rem]="0.8"
           aria-hidden="true"></i>
    </button>
    <dialog [id]="warrantyAndReturnsModalId"
            [side]="'right'">
        <ng-container ngProjectAs="[dialogTitle]">
            {{'Warranty & Returns' | translate}}
        </ng-container>
        <product-view-warranty-and-returns-modal [product]="product" />
    </dialog>
    }
    <product-range-content class="m-t-8 m-b-7"
                           [variant]="product.rangeContentVariant"
                           *ifSize="'SM'" />
    <product-view-description [product]="product"
                              [content]="content"
                              *ifSize="'SM'" />
</ng-template>